/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable no-restricted-globals  */
import React, { useEffect } from 'react';
import * as XLSX from 'xlsx';

const ExcelSheetFile = (props) => {
  const { reportData, filename, pdfoption } = props;
  reportData.report_dict.pdfoption = pdfoption;
  const getFlowValue = (item, num = 2, flow) => {
    if (flow === 'm3/s') {
      if (item >= 0.01) {
        return Number.parseFloat(item).toFixed(num);
      }
      return Number.parseFloat(item).toExponential(num);
    }
    return Number.parseFloat(item).toFixed(num);
  };
  const clroOverViewContent = (ele, unit, val, ind, clroOverView, element, clro_elem_system_units) => {
    // const num = Object.prototype.toString.call(clroOverView[element]) === '[object Object]' ? Object.keys(clroOverView[element]).length - 1 : 0;
    let values = val;
    if (Object.prototype.toString.call(values) === '[object Number]' && values.toString().indexOf('.') >= 0) {
      values = getFlowValue(val, 2, clro_elem_system_units['Volume Flow']);
    }
    return [ele, unit, values];
  };
  const getFloatVal = (val, str = '') => {
    if (str) {
      const data = val.split(' ');
      if (!Number.isNaN(Number(data[0]))) {
        return `${Number(data[0]).toFixed(2)} ${data[1]}`;
      }
      return val;
    }
    if (!Number.isNaN(Number(val))) {
      return Number(val).toFixed(2);
    }
    return val;
  };
  const createExcelData = (uniqueData, uniqueKey) => {
    let ro_unitop_systemlevel_header = [uniqueKey, ''];
    ro_unitop_systemlevel_header = ro_unitop_systemlevel_header.concat(uniqueData[uniqueKey]);
    const ro_unitop_systemlevel_exceldata = Object.keys(uniqueData.units).map((ele) => {
      const data = uniqueData[uniqueKey].map((unitId) => {
        if (Object.prototype.toString.call(uniqueData[unitId][ele]) === '[object Number]') {
          const val = uniqueData[unitId][ele];
          if (['Feed Flow', 'Product Flow', 'Concentrate Flow', 'Flow Rate'].indexOf(ele) >= 0) {
            return getFlowValue(val, 2, uniqueData.units[ele]);
          }
          return getFlowValue(val, 2, '');
        }
        let trimdata = uniqueData[unitId][ele].trim();
        // if (trimdata.length - 1 === trimdata.lastIndexOf(',')) {
        //   trimdata = trimdata.substring(0, trimdata.length - 1);
        // }

        // code guru
        if (trimdata.endsWith(',')) {
          trimdata = trimdata.slice(0, -1);
        }
        if (trimdata) {
          trimdata = trimdata.split(',').map((conData) => {
            if (!isNaN(Number(conData))) {
              return getFlowValue(conData, 2, '');
            }
            return conData;
          });
          trimdata = trimdata.join(',');
        }
        return trimdata;
      });
      let final_data = [ele, uniqueData.units[ele]];
      final_data = final_data.concat(data);
      return final_data;
    });
    ro_unitop_systemlevel_exceldata.splice(0, 0, ro_unitop_systemlevel_header);
    return ro_unitop_systemlevel_exceldata;
  };
  const appendNumberText = (value, floatdecimal = 2) => {
    if (value === undefined) {
      return '-';
    }
    if (Number.isNaN(Number(value))) { // checking values is number or not ----> Kranthi
      const split_Val = value.split(' '); // spliting all the value with space ----> Kranthi
      if (split_Val.length > 1) { // checking split value have more that two vlaue  ----> Kranthi
        const num_val = Number(split_Val[0]).toFixed(floatdecimal);
        const text_val = split_Val[1];
        return `${num_val} ${text_val}`; // combing text and value ----> Kranthi
      }
      const split_perval = value.split('%'); // spliting all the value with % ----> Kranthi
      if (split_perval.length > 1) { // checking split value have more that two vlaue  ----> Kranthi
        const num_val = Number(split_perval[0]).toFixed(floatdecimal);
        return `${num_val}`; // showing text ----> Kranthi
      }
      return value;
    }
    return Number(value).toFixed(floatdecimal);
  };
  const getFlowsheetAllValues = (stream_output) => {
    const items = Object.keys(stream_output);
    let tempval = true;
    const { temp } = stream_output[items[0]];
    Object.values(stream_output).forEach(ele => {
      if (Number(ele.temp).toFixed(2) !== Number(temp).toFixed(2)) {
        tempval = false;
      }
    });
    const data = [
      ['Stream Id', 'Stream Name', `Flow, ${reportData.report_dict.system_units['Volume Flow']}`, `Temperature, ${reportData.report_dict.system_units.Temperature}`, `Pressure, ${reportData.report_dict.system_units.Pressure}`, 'TDS, mg/l', 'Alkalinity, ppm CaCO3', 'Hardness, ppm as CaCO3', 'pH', 'Conductivity at 25°C, µS/cm']
    ];
    if (tempval) {
      data[0].splice(3, 1);
    }
    items.map((ele) => {
      if (stream_output[ele]) {
        const { sat_indices, prop_dict } = stream_output[ele];
        const allVal = [
          ele,
          stream_output[ele].label ? stream_output[ele].label : '',
          prop_dict.flow,
          prop_dict.temp,
          prop_dict.press,
          prop_dict.tds,
          prop_dict.malk,
          stream_output[ele].hardness,
          prop_dict.ph,
          sat_indices.conductivity
        ];
        if (tempval) {
          allVal.splice(3, 1);
        }
        return data.push(allVal);
      }
    });
    return data;
  };
  const handleExportExcel = () => {
    const workbook = XLSX.utils.book_new();
    // FlowSheet Design Summary (Stream Property Summary) Start
    if (reportData.report_dict.stream_output && Object.keys(reportData.report_dict.stream_output).length) {
      // const flowsheetDesignSummaryData = {
      //   flow: `Flow, ${reportData.report_dict.system_units['Volume Flow']}`,
      //   temp: `Temperature, ${reportData.report_dict.system_units.Temperature}`,
      //   press: `Pressure, ${reportData.report_dict.system_units.Pressure}`,
      //   tds: 'TDS, mg/l',
      //   ph: 'pH',
      //   malk: 'Alkalinity, ppm CaCO3',
      //   hardness: 'Hardness, ppm as CaCO3 ',
      //   density: 'Density, kg/m3',
      //   ionic_strength: 'Ionic Strength',
      //   osmotic_pressure: `Osmotic Pressure, ${reportData.report_dict.system_units.Pressure}`,
      //   conductivity: 'Conductivity at 25°C, µS/cm '
      // };
      // const flowsheetDesignSummaryFinalArray = [];
      // const flowsheetDesignStreamOutput = Object.keys(reportData.report_dict.stream_output);
      // flowsheetDesignSummaryFinalArray.push(flowsheetDesignStreamOutput);
      // Object.keys(flowsheetDesignSummaryData).map((ele, ind) => {
      //   const arr = [flowsheetDesignSummaryData[ele]];
      //   flowsheetDesignStreamOutput.map((data, index) => {
      //     let val = '';
      //     if (['flow', 'temp', 'press', 'tds', 'ph', 'malk'].indexOf(ele) >= 0) {
      //       val = reportData.report_dict.stream_output[data].prop_dict[ele];
      //     } else if (['hardness', 'ionic_strength'].indexOf(ele) >= 0) {
      //       val = reportData.report_dict.stream_output[data][ele];
      //     } else if (['density', 'osmotic_pressure', 'conductivity'].indexOf(ele) >= 0) {
      //       val = reportData.report_dict.stream_output[data].sat_indices[ele];
      //     }
      //     if (val !== '') {
      //       arr.push(getFlowValue(val, 2, reportData.report_dict.system_units['Volume Flow']));
      //     }
      //   });
      //   flowsheetDesignSummaryFinalArray.push(arr);
      // });
      // flowsheetDesignStreamOutput.unshift('Parameter');
      const flowsheetDesignSummaryFinalArray = getFlowsheetAllValues(reportData.report_dict.stream_output);
      const flowsheet_design_summary = XLSX.utils.aoa_to_sheet(flowsheetDesignSummaryFinalArray);
      XLSX.utils.book_append_sheet(workbook, flowsheet_design_summary, 'Flowsheet Design Summary');
    }
    // FlowSheet Design Summary (Stream Property Summary) End
    // FSD Flow Balance Start
    if (reportData.report_dict.coverpage_dict.flow_bal && Object.keys(reportData.report_dict.coverpage_dict.flow_bal).length) {
      const fsdFlowBalanceData = [
        ['Parameter', '', 'Incoming', 'Outgoing', ''],
        ['', '', '', 'Product', 'Waste'],
      ];
      const fsdmergeCell = [
        { s: { r: 0, c: 0 }, e: { r: 1, c: 1 } }, // A1:B2
        { s: { r: 0, c: 2 }, e: { r: 1, c: 2 } }, // C1:C2
        { s: { r: 0, c: 3 }, e: { r: 0, c: 4 } }, // D1:E1
        { s: { r: 5, c: 0 }, e: { r: 5, c: 4 } }, // A6:E6
      ];
      const fsd_items = reportData.report_dict.coverpage_dict.flow_bal;
      const fsd_obj = ['Unit ID (Stream no.)', 'Flow', 'Flow - Total', 'Overall Flow Sheet Recovery'];
      const fsd_data = Object.keys(fsd_items);
      fsd_data.map((item, parentInd) => {
        let finalData;
        if (Object.prototype.toString.call(fsd_items[item]) === '[object Object]') {
          finalData = Object.values(fsd_items[item]);
          finalData.forEach((ele, ind) => {
            if (Object.prototype.toString.call(ele) === '[object Array]') {
              finalData[ind] = ele.map((e) => {
                if (Object.prototype.toString.call(e) === '[object Number]') {
                  return getFlowValue(e, 2, reportData.report_dict.system_units['Volume Flow']);
                }
                return e;
              });
            } else if (Object.prototype.toString.call(ele) === '[object Number]') {
              finalData[ind] = getFlowValue(ele, 2, reportData.report_dict.system_units['Volume Flow']);
            }
          });
          finalData.unshift(fsd_obj[parentInd]);
        } else {
          finalData = [`${fsd_obj[parentInd]} = ${getFloatVal(fsd_items[item])}%`];
        }
        fsdFlowBalanceData.push(finalData);
      });
      const fsdFlowBalance = XLSX.utils.aoa_to_sheet(fsdFlowBalanceData);
      fsdFlowBalance['!merges'] = fsdmergeCell;
      XLSX.utils.book_append_sheet(workbook, fsdFlowBalance, 'FSD Flow Balance');
    }
    // FSD Flow Balance End
    // Desalination \ Demineralization \ Membrane Separator (MEMS) Unit-Level Flow Summary Start
    if (reportData.report_dict.coverpage_dict.flow_summary && Object.keys(reportData.report_dict.coverpage_dict.flow_summary).length) {
      const desalinationCell = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: 1 } }, // A1:B1
        { s: { r: 0, c: 2 }, e: { r: 1, c: 2 } }, // C1:C2
        { s: { r: 0, c: 3 }, e: { r: 1, c: 3 } }, // D1:D2
        { s: { r: 0, c: 4 }, e: { r: 1, c: 4 } }, // E1:E2
        { s: { r: 0, c: 5 }, e: { r: 1, c: 5 } }, // F1:F2
        { s: { r: 0, c: 6 }, e: { r: 1, c: 6 } }, // G1:G2
      ];
      const desalinationKeys = Object.keys(reportData.report_dict.coverpage_dict.flow_summary);
      const desalinationData = [];
      const desalination_firstHeader = [];
      const desalination_secondHeader = [];
      desalinationKeys.map((ele) => {
        if (ele === 'Type' || ele === 'ID') {
          desalination_secondHeader.push(ele);
          if (ele === 'Type') {
            desalination_firstHeader.push('Unitop', '');
          }
        } else {
          if (ele === 'Recovery') {
            desalination_firstHeader.push(`${ele} (%)`);
          } else if (ele === 'Waste') {
            desalination_firstHeader.push(`Conc. (${reportData.report_dict.system_units['Volume Flow']})`);
          } else if (ele === 'Electrode') {
            desalination_firstHeader.push(`${ele} Bleed (${reportData.report_dict.system_units['Volume Flow']})`);
          } else if (['Feed', 'Product'].indexOf(ele) >= 0) {
            desalination_firstHeader.push(`${ele} (${reportData.report_dict.system_units['Volume Flow']})`);
          }
          desalination_secondHeader.push('');
        }
      });
      desalinationData.push(desalination_firstHeader, desalination_secondHeader);
      const desalination_items = reportData.report_dict.coverpage_dict.flow_summary;
      desalination_items.Type.map((type) => {
        const id = desalination_items.ID[type][0];
        const recovery = desalination_items.Recovery[id] ? getFlowValue(desalination_items.Recovery[id], 2, '') : '-';
        const feed = desalination_items.Feed[id] ? getFlowValue(desalination_items.Feed[id], 2, reportData.report_dict.system_units['Volume Flow']) : '-';
        const product = desalination_items.Product[id] ? getFlowValue(desalination_items.Product[id], 2, reportData.report_dict.system_units['Volume Flow']) : '-';
        const waste = desalination_items.Waste[id] ? getFlowValue(desalination_items.Waste[id], 2, reportData.report_dict.system_units['Volume Flow']) : '-';
        const electrode = desalination_items.Electrode[id] ? getFlowValue(desalination_items.Electrode[id], 2, '') : '-';
        desalinationData.push([type, id, recovery, feed, product, waste, electrode]);
      });
      const desalination_flowBalance = XLSX.utils.aoa_to_sheet(desalinationData);
      desalination_flowBalance['!merges'] = desalinationCell;
      XLSX.utils.book_append_sheet(workbook, desalination_flowBalance, 'Desalination Demineralization');
    }
    // Desalination \ Demineralization \ Membrane Separator (MEMS) Unit-Level Flow Summary End
    // Feed-Product-Waste Summary Start
    if (reportData.report_dict.feed_product_waste_summary && Object.keys(reportData.report_dict.feed_product_waste_summary).length) {
      const feed_waste_summary = reportData.report_dict.feed_product_waste_summary;
      const feed_waste_summary_arr = [];
      const feed_waste_header = ['Category', 'Parameter', ''].concat(feed_waste_summary['Unit ID']);
      Object.values(feed_waste_summary.Category).map((wasteEle) => {
        if (Object.prototype.toString.call(feed_waste_summary.Parameter[wasteEle]) === '[object String]') {
          const arr = [wasteEle];
          arr.push(feed_waste_summary.Parameter[wasteEle], feed_waste_summary.Units[wasteEle]);
          feed_waste_summary['Unit ID'].map((unitEle) => {
            arr.push(feed_waste_summary[unitEle][wasteEle]);
          });
          feed_waste_summary_arr.push(arr);
        } else if (Object.prototype.toString.call(feed_waste_summary.Parameter[wasteEle]) === '[object Array]') {
          feed_waste_summary.Parameter[wasteEle].map((parEle) => {

            const arr = [wasteEle, parEle, feed_waste_summary.Units[wasteEle][parEle]];
            feed_waste_summary['Unit ID'].map((unitEle) => {
              if (wasteEle === 'Stream Property' && parEle === 'Flow') {
                arr.push(getFlowValue(feed_waste_summary[unitEle][wasteEle][parEle], 2, feed_waste_summary.Units[wasteEle][parEle]));
              } else {
                arr.push(getFlowValue(feed_waste_summary[unitEle][wasteEle][parEle], 2));
              }
            });
            feed_waste_summary_arr.push(arr);
          });
        }
      });
      feed_waste_summary_arr.unshift(feed_waste_header);
      const feed_waste_summary_excel_data = XLSX.utils.aoa_to_sheet(feed_waste_summary_arr);
      const feed_waste_existingValue = [];
      const feed_waste_celldata = [
        { s: { r: 0, c: 1 }, e: { r: 0, c: 2 } },
      ];
      for (let i = 0; i < feed_waste_summary_arr.length; i += 1) {
        let count = 0;
        if (['Category'].indexOf(feed_waste_summary_arr[i][0]) === -1) {
          if (feed_waste_existingValue.indexOf(feed_waste_summary_arr[i][0]) === -1) {
            feed_waste_existingValue.push(feed_waste_summary_arr[i][0]);
            for (let j = i + 1; j < feed_waste_summary_arr.length; j += 1) {
              if (feed_waste_summary_arr[i][0] === feed_waste_summary_arr[j][0]) {
                count += 1;
              }
            }
            feed_waste_celldata.push(
              { s: { r: i, c: 0 }, e: { r: i + count, c: 0 } },
            );
          }
        }
      }
      feed_waste_summary_excel_data['!merges'] = feed_waste_celldata;
      XLSX.utils.book_append_sheet(workbook, feed_waste_summary_excel_data, 'Feed-Product-Waste Summary');
    }
    // Feed-Product-Waste Summary End
    // RO Unitop System-Level Summary Start
    if (reportData.report_dict.ro_summary && Object.keys(reportData.report_dict.ro_summary).length && reportData.report_dict.ro_summary.ro_system_dict && Object.keys(reportData.report_dict.ro_summary.ro_system_dict).length) {
      const ro_unitop_systemlevel_data = reportData.report_dict.ro_summary.ro_system_dict;
      const ro_unitop_systemlevel_exceldata = createExcelData(ro_unitop_systemlevel_data, 'RO Unit ID');
      const ro_unitop_systemlevel_cellData = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: 1 } }, // A1:B1
      ];
      const ro_unitop_systemlevel_final_data = XLSX.utils.aoa_to_sheet(ro_unitop_systemlevel_exceldata);
      ro_unitop_systemlevel_final_data['!merges'] = ro_unitop_systemlevel_cellData;
      XLSX.utils.book_append_sheet(workbook, ro_unitop_systemlevel_final_data, 'RO Unitop System-Level Summary');
    }
    // RO Unitop System-Level Summary End
    // RO Unitop System-Level Summary Details Design Start
    if (reportData.report_dict.ro_hp.ro_dict && Object.keys(reportData.report_dict.ro_hp.ro_dict).length) {
      const ro_unitop_ro_hp_data = reportData.report_dict.ro_hp.ro_dict;
      const ro_unitop_ro_hp_final_data = [];
      // Object.keys(ro_unitop_ro_hp_data).map((ele, ind) => {
      reportData.report_dict.ro_summary.ro_system_dict['RO Unit ID'].map((ele, ind) => {
        let header_val = [[
          'Stage',
          'Housing',
          'Elements',
          'Element Type',
          'Element Age (yr) ',
          `Pressure Change, ${reportData.report_dict.system_units.Pressure}`,
          '',
          `Permeate P  (${reportData.report_dict.system_units.Pressure})`,
          reportData.report_dict.ro_hp.abFactor === 0 ? 'A-Value ACP' : 'A-Factor',
          reportData.report_dict.ro_hp.abFactor === 0 ? 'B-Value ACP' : 'B-Factor'
        ]];
        header_val.push(['', '', '', '', '', 'Boost', 'Loss', '', '', '']);
        let arrayData = ['stage', 'pressureVessels', 'elementsperVessel', 'elementModel', 'elementAge', 'interStageBoostPressure', 'interStagePressureLoss', 'permeatePressure', 'fluxAnnual', 'saltPassageAnnual'];
        if (ro_unitop_ro_hp_data[ele].unit_type === 'CLRO') {
          arrayData = ['stage', 'pressureVessels', 'elementsperVessel', 'spacersperVessel', 'elementModel', 'elementAge', 'permeatePressure', 'fluxAnnual', 'saltPassageAnnual'];
          header_val = [[
            'Stage',
            'Housing',
            'Elements',
            'Spacers per Vessel',
            'Element Type',
            'Element Age (yr)',
            `Permeate P (${reportData.report_dict.system_units.Pressure})`,
            reportData.report_dict.ro_hp.abFactor === 0 ? 'A-Value ACP' : 'A-Factor',
            reportData.report_dict.ro_hp.abFactor === 0 ? 'B-Value ACP' : 'B-Factor'
          ]];
        }
        Object.keys(ro_unitop_ro_hp_data[ele]['grid-data']).map((gridData) => {
          if (ro_unitop_ro_hp_data[ele]['grid-data'][gridData].pressureVessels !== 0) {
            const finalData = [];
            arrayData.map((arrEle) => {
              finalData.push(ro_unitop_ro_hp_data[ele]['grid-data'][gridData][arrEle]);
            });
            header_val.push(finalData);
            return finalData;
          }
        });
        ro_unitop_ro_hp_final_data[ind] = header_val;
      });
      const ro_unitop_ro_hp_celldata = [];
      const ro_unitop_ro_hp_excel_data = XLSX.utils.aoa_to_sheet([''.split('')]);
      ro_unitop_ro_hp_final_data.map((ele, ind) => {
        let startingrow = 0;
        for (let k = 0; k < ind; k += 1) {
          startingrow += ro_unitop_ro_hp_final_data[k].length;
        }
        if (startingrow >= 0) {
          startingrow += ind;
          if (ro_unitop_ro_hp_final_data[ind][0].length === 10) {
            ro_unitop_ro_hp_celldata.push(
              { s: { r: startingrow, c: 0 }, e: { r: startingrow + 1, c: 0 } },
              { s: { r: startingrow, c: 1 }, e: { r: startingrow + 1, c: 1 } },
              { s: { r: startingrow, c: 2 }, e: { r: startingrow + 1, c: 2 } },
              { s: { r: startingrow, c: 3 }, e: { r: startingrow + 1, c: 3 } },
              { s: { r: startingrow, c: 4 }, e: { r: startingrow + 1, c: 4 } },
              { s: { r: startingrow, c: 5 }, e: { r: startingrow, c: 6 } },
              { s: { r: startingrow, c: 7 }, e: { r: startingrow + 1, c: 7 } },
              { s: { r: startingrow, c: 8 }, e: { r: startingrow + 1, c: 8 } },
              { s: { r: startingrow, c: 9 }, e: { r: startingrow + 1, c: 9 } },
            );
          }
        }
        /* origin add to staring row in excel */
        XLSX.utils.sheet_add_aoa(ro_unitop_ro_hp_excel_data, ele, { origin: { r: startingrow, c: 0 } });
      });
      ro_unitop_ro_hp_excel_data['!merges'] = ro_unitop_ro_hp_celldata;
      XLSX.utils.book_append_sheet(workbook, ro_unitop_ro_hp_excel_data, 'RO Unitop Details Design');
    }
    // RO Unitop System-Level Summary Details Design End
    // RO Unitop Stage-Level Summary Details Design Start
    if (reportData.report_dict.ro_summary.ro_stage_dict && Object.keys(reportData.report_dict.ro_summary.ro_stage_dict).length) {
      const ro_stage_dict_data = reportData.report_dict.ro_summary.ro_stage_dict;
      const ro_stage_dict_header_val = [];
      // Object.keys(ro_stage_dict_data).map((ele, ind) => {
      reportData.report_dict.ro_summary.ro_system_dict['RO Unit ID'].map((ele, ind) => {
        const header_val = [[
          'Stage',
          'Housing',
          'Elements',
          'Element Type',
          `Flow (${reportData.report_dict.system_units['Volume Flow']})`,
          '', '',
          'Recovery (%)',
          `Flux (${reportData.report_dict.system_units.Flux})`,
          `Pressure (${reportData.report_dict.system_units.Pressure})`,
          '',
          'TDS (mg/L)', '',
          'Last Element Beta'
        ], ['', '', '', '', 'Feed', 'Conc.', 'Perm.', '', '', 'Feed', 'dP', 'Feed', 'Perm.', '']];
        Object.keys(ro_stage_dict_data[ele].Stage).map((stageData, stageInd) => {
          const data = ['Housing', 'Elements', 'Element Type', 'Flow', 'Conc.', 'Perm.', '% Recovery', 'Flux', 'Feed Pressure', 'Pressure dp', 'Feed TDS mg/L', 'Perm TDS mg/L', 'Last Elem Beta'].map((data) => {
            if (data === 'Element Type') {
              const rodata = reportData.report_dict.ro_hp.ro_dict;
              if (rodata[ele] && rodata[ele]['grid-data'] && rodata[ele]['grid-data'][stageInd] && rodata[ele]['grid-data'][stageInd].elementModel) {
                return rodata[ele]['grid-data'][stageInd].elementModel;
              }
            }
            if (['Flow', 'Conc.', 'Perm.'].indexOf(data) >= 0) {
              return getFlowValue(ro_stage_dict_data[ele].Stage[stageData][data], 2, reportData.report_dict.system_units['Volume Flow']);
            }
            return getFlowValue(ro_stage_dict_data[ele].Stage[stageData][data], 2);
          });
          data.unshift(stageData);
          header_val.push(data);
          ro_stage_dict_header_val[ind] = header_val;
        });
      });
      const ro_stage_dict_celldata = [];
      const ro_stage_dict_excel_data = XLSX.utils.aoa_to_sheet([''.split('')]);
      ro_stage_dict_header_val.map((ele, ind) => {
        let startingrow = 0;
        for (let k = 0; k < ind; k += 1) {
          startingrow += ro_stage_dict_header_val[k].length;
        }
        if (startingrow >= 0) {
          startingrow += ind;
          ro_stage_dict_celldata.push(
            { s: { r: startingrow, c: 0 }, e: { r: startingrow + 1, c: 0 } },
            { s: { r: startingrow, c: 1 }, e: { r: startingrow + 1, c: 1 } },
            { s: { r: startingrow, c: 2 }, e: { r: startingrow + 1, c: 2 } },
            { s: { r: startingrow, c: 3 }, e: { r: startingrow + 1, c: 3 } },
            { s: { r: startingrow, c: 4 }, e: { r: startingrow, c: 6 } },
            { s: { r: startingrow, c: 7 }, e: { r: startingrow + 1, c: 7 } },
            { s: { r: startingrow, c: 8 }, e: { r: startingrow + 1, c: 8 } },
            { s: { r: startingrow, c: 9 }, e: { r: startingrow, c: 10 } },
            { s: { r: startingrow, c: 11 }, e: { r: startingrow, c: 12 } },
            { s: { r: startingrow, c: 13 }, e: { r: startingrow + 1, c: 13 } }
          );
        }
        /* origin add to staring row in excel */
        XLSX.utils.sheet_add_aoa(ro_stage_dict_excel_data, ele, { origin: { r: startingrow, c: 0 } });
      });
      ro_stage_dict_excel_data['!merges'] = ro_stage_dict_celldata;
      XLSX.utils.book_append_sheet(workbook, ro_stage_dict_excel_data, 'RO Unitop Stage-Level Summary');
    }
    // RO Unitop Stage-Level Summary Details Design End
    // Pump Summary Start
    if (reportData.report_dict.pump_summary && Object.keys(reportData.report_dict.pump_summary).length) {
      const pump_summary_data = reportData.report_dict.pump_summary;
      const pump_summary_exceldata = createExcelData(pump_summary_data, 'Pump Unit ID');
      pump_summary_exceldata.push([`Total Power Consumption (kW) = ${getFlowValue(pump_summary_data['Total Power Consumption (kW)'], 2)}`]);
      const mergeCellInd = Object.keys(pump_summary_data.units).length + 1;
      const pump_summary_cellData = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: 1 } }, // A1:B1
        { s: { r: mergeCellInd, c: 0 }, e: { r: mergeCellInd, c: pump_summary_exceldata[0].length - 1 } }, // A1:B1
      ];
      const pump_summary_final_data = XLSX.utils.aoa_to_sheet(pump_summary_exceldata);
      pump_summary_final_data['!merges'] = pump_summary_cellData;
      XLSX.utils.book_append_sheet(workbook, pump_summary_final_data, 'Pump Summary');
    }
    // Pump Summary End
    // Detailed RO Element-Level Data Start
    if (reportData.report_dict.ro_elem_summary && Object.keys(reportData.report_dict.ro_elem_summary).length) {
      const ro_elem_summary_final_array = [];
      const { ro_elem_summary } = reportData.report_dict;
      ro_elem_summary['RO Unit ID'].map((element) => {
        Object.keys(ro_elem_summary[element]).map((headerCreate, headerCreateInd) => {
          const ro_elem_summary_array = [];
          const firstHeader = ['Category', 'Parameter', 'Stage No.'];
          const secondHeader = ['', '', 'Element Pos.'];
          firstHeader.push(headerCreateInd + 1);
          Object.keys(ro_elem_summary[element][headerCreate]).map((ele, ind) => {
            secondHeader.push(Number(ele) + 1);
            if (ind > 0)
              firstHeader.push('');
          });
          ro_elem_summary_array.push(firstHeader, secondHeader);
          const roUnits = ro_elem_summary.units;
          const reportContent = ro_elem_summary[element];
          Object.keys(roUnits).map((category) => {
            Object.keys(roUnits[category]).map((subCat) => {
              const data = [headerCreate];
              const arr = [category, subCat, roUnits[category][subCat]];
              data.map((content) => {
                const contentKey = Object.keys(reportContent[content]);
                contentKey.map((key) => {
                  if (category === 'Flow') {
                    arr.push(getFlowValue(reportContent[content][key].Category[category][subCat], 2, reportData.report_dict.system_units['Volume Flow']));
                  } else {
                    arr.push(getFlowValue(reportContent[content][key].Category[category][subCat], 2, ''));
                  }
                });
              });
              ro_elem_summary_array.push(arr);
            });
          });
          ro_elem_summary_final_array.push(ro_elem_summary_array);
        });
      });
      const ro_elem_summary_celldata = [];
      const ro_elem_summary_excel_data = XLSX.utils.aoa_to_sheet([''.split('')]);
      ro_elem_summary_final_array.map((ele, ind) => {
        let startingrow = 0;
        for (let k = 0; k < ind; k += 1) {
          startingrow += ro_elem_summary_final_array[k].length;
        }
        if (startingrow >= 0) {
          startingrow += ind;
          ro_elem_summary_celldata.push(
            { s: { r: startingrow, c: 0 }, e: { r: startingrow + 1, c: 0 } },
            { s: { r: startingrow, c: 1 }, e: { r: startingrow + 1, c: 1 } },
            { s: { r: startingrow, c: 3 }, e: { r: startingrow, c: ro_elem_summary_final_array[ind][1].length - 1 } }
          );
        }
        const existingValue = [];
        for (let i = 0; i < ele.length; i += 1) {
          let count = 0;
          if (['Category', ''].indexOf(ele[i][0]) === -1) {
            if (existingValue.indexOf(ele[i][0]) === -1) {
              existingValue.push(ele[i][0]);
              for (let j = i + 1; j < ele.length; j += 1) {
                if (ele[i][0] === ele[j][0]) {
                  count += 1;
                }
              }
              ro_elem_summary_celldata.push(
                { s: { r: i + startingrow, c: 0 }, e: { r: i + startingrow + count, c: 0 } },
              );
            }
          }
        }
        XLSX.utils.sheet_add_aoa(ro_elem_summary_excel_data, ele, { origin: { r: startingrow, c: 0 } });
      });
      ro_elem_summary_excel_data['!merges'] = ro_elem_summary_celldata;
      XLSX.utils.book_append_sheet(workbook, ro_elem_summary_excel_data, 'Detailed RO Element-Level Data');
    }
    // Detailed RO Element-Level Data End
    // Detailed Stream Data Start
    if (reportData.report_dict.stream_output && Object.keys(reportData.report_dict.stream_output).length && reportData.report_dict.stream_input_dict && Object.keys(reportData.report_dict.stream_input_dict).length) {
      const detailed_stream_data = [
        {
          key: 'Stream Info',
          subKey: [
            { key: 'Source Unitop', keyVal: 'source', unit: '' },
            { key: 'Destination Unitop', keyVal: 'destination', unit: '' },
          ],
        },
        {
          key: 'Ion Concentration',
          subKey: [
            { key: 'Calcium (Ca)', keyVal: 'Ca++', unit: 'mg/L' },
            { key: 'Magnesium (Mg)', keyVal: 'Mg++', unit: 'mg/L' },
            { key: 'Sodium (Na)', keyVal: 'Na+', unit: 'mg/L' },
            { key: 'Potassium (K)', keyVal: 'K+', unit: 'mg/L' },
            { key: 'Ammonia - N (NH4)', keyVal: 'NH4+', unit: 'mg/L' },
            { key: 'Barium (Ba)', keyVal: 'Ba++', unit: 'mg/L' },
            { key: 'Strontium (Sr)', keyVal: 'Sr++', unit: 'mg/L' },
            { key: 'Iron (Fe)', keyVal: 'Fe++', unit: 'mg/L' },
            { key: 'Manganese (Mn)', keyVal: 'Mn++', unit: 'mg/L' },
            { key: 'Sulfate (SO4)', keyVal: 'SO4--', unit: 'mg/L' },
            { key: 'Chloride (Cl)', keyVal: 'Cl-', unit: 'mg/L' },
            { key: 'Fluoride (F)', keyVal: 'F-', unit: 'mg/L' },
            { key: 'Nitrate (NO3)', keyVal: 'NO3-', unit: 'mg/L' },
            { key: 'Bromide (Br)', keyVal: 'Br-', unit: 'mg/L' },
            { key: 'Phosphate (PO4)', keyVal: 'PO4---', unit: 'mg/L' },
            { key: 'Boron (B)', keyVal: 'B-', unit: 'mg/L' },
            { key: 'Silica (SiO2)', keyVal: 'SiO2', unit: 'mg/L' },
            { key: 'Hydrogen Sulfide (H2S)', keyVal: 'H2S', unit: 'mg/L' },
            { key: 'Bicarbonate (HCO3)', keyVal: 'HCO3-', unit: 'mg/L' },
            { key: 'Carbon Dioxide (CO2)', keyVal: 'CO2', unit: 'mg/L' },
            { key: 'Carbonate (CO3)', keyVal: 'CO3--', unit: 'mg/L' },
            { key: 'TDS, mg/l', keyVal: 'TDS', unit: 'mg/L' },
          ],
        },
        {
          key: 'Stream Property',
          subKey: [
            { key: 'Flow', keyVal: 'flow', unit: reportData.report_dict.system_units['Volume Flow'] },
            { key: 'Pressure', keyVal: 'press', unit: reportData.report_dict.system_units.Pressure },
            { key: 'Temperature', keyVal: 'temp', unit: reportData.report_dict.system_units.Temperature },
            { key: 'pH', keyVal: 'ph', unit: '' },
            { key: 'Alkalinity', keyVal: 'malk', unit: 'ppm CaCO3' },
            { key: 'Conductivity at 25°C', keyVal: 'conductivity', unit: 'µS/cm' },
            { key: 'Hardness', keyVal: 'hardness', unit: 'ppm as CaCO3' },
            { key: 'Density', keyVal: 'density', unit: 'kg/m3' },
            { key: 'Ionic Strength', keyVal: 'ionic_str', unit: '' },
            { key: 'Osm. Pressure', keyVal: 'osmotic_pressure', unit: reportData.report_dict.system_units.Pressure },
          ],
        },
        {
          key: 'Saturation Data',
          subKey: [
            { key: 'BaSO4', keyVal: 'baso4', unit: '%' },
            { key: 'CaF2', keyVal: 'caf2', unit: '%' },
            { key: 'Mg(OH)2', keyVal: 'mgoh2', unit: '%' },
            { key: 'SiO2', keyVal: 'sio2', unit: '%' },
            { key: 'SrSO4', keyVal: 'srso4', unit: '%' },
            { key: 'Struvite', keyVal: 'struvite', unit: '%' },
            { key: 'LSI', keyVal: 'lsi', unit: '' },
            { key: 'SDSI', keyVal: 'sdi', unit: '' },
          ],
        },
      ];
      let detailed_stream_hearder_val = ['Category', 'Parameter', 'Stream ID'];
      detailed_stream_hearder_val = detailed_stream_hearder_val.concat(Object.keys(reportData.report_dict.stream_output));
      const detailed_stream_input = reportData.report_dict.stream_input_dict;
      const detailed_stream_output = reportData.report_dict.stream_output;
      const { ediOutputData } = reportData.report_dict || [];
      const detailed_stream_final_array = [];
      detailed_stream_data.map((keys) => {
        keys.subKey.map((subkey) => {
          const final_data = [keys.key, keys.key === 'Ion Concentration' ? subkey.keyVal : subkey.key, subkey.unit];
          detailed_stream_hearder_val.slice(3).map((val) => {
            if (keys.key === 'Stream Info') {
              final_data.push(detailed_stream_input[val][subkey.keyVal]);
            } else if (keys.key === 'Ion Concentration') {
              const flag = ediOutputData.filter((edio) => {
                return detailed_stream_output[val].label.toLowerCase().indexOf(edio.target) > 0;
              });
              if (subkey.keyVal === 'TDS') {
                if (flag.length > 0) {
                  final_data.push(appendNumberText(detailed_stream_output[val].prop_dict.tds, 5));
                } else {
                  final_data.push(appendNumberText(detailed_stream_output[val].prop_dict.tds, 3));
                }
              } else if (flag.length > 0) {
                final_data.push(appendNumberText(detailed_stream_output[val].ppm_dict[subkey.keyVal], 5));
              } else {
                final_data.push(appendNumberText(detailed_stream_output[val].ppm_dict[subkey.keyVal], 3));
              }
            } else if (keys.key === 'Stream Property') {
              if (subkey.keyVal === 'flow') {
                let convertVal = detailed_stream_output[val].sat_indices[subkey.keyVal];
                if (convertVal) {
                  convertVal = getFlowValue(detailed_stream_output[val].sat_indices[subkey.keyVal], 2, subkey.unit);
                }
                final_data.push(convertVal || '-');
              } else if (subkey.keyVal === 'osmotic_pressure' || subkey.keyVal === 'conductivity') {
                if (subkey.keyVal === 'conductivity') {
                  const flag = ediOutputData.filter((edio) => {
                    return detailed_stream_output[val].label.toLowerCase().indexOf(edio.target) > 0;
                  });
                  if (flag.length > 0) {
                    final_data.push(appendNumberText(detailed_stream_output[val].sat_indices[subkey.keyVal], 4));
                  } else {
                    final_data.push(appendNumberText(detailed_stream_output[val].sat_indices[subkey.keyVal], 1));
                  }
                } else {
                  final_data.push(appendNumberText(detailed_stream_output[val].sat_indices[subkey.keyVal]));
                }
              } else {
                final_data.push(appendNumberText(detailed_stream_output[val].prop_dict[subkey.keyVal]));
              }
            } else {
              final_data.push(appendNumberText(detailed_stream_output[val].sat_indices[subkey.keyVal]));
            }
          });
          detailed_stream_final_array.push(final_data);
        });
      });
      detailed_stream_final_array.unshift(detailed_stream_hearder_val);
      const detailed_stream_celldata = [];
      const detailed_stream_excel_data = XLSX.utils.aoa_to_sheet(detailed_stream_final_array);
      const detailed_stream_existingValue = [];
      detailed_stream_final_array.map((ele, ind) => {
        let count = 0;
        if (detailed_stream_existingValue.indexOf(ele[0]) === -1) {
          detailed_stream_existingValue.push(ele[0]);
          for (let k = 0; k < detailed_stream_final_array.length; k += 1) {
            if (ele[0] === detailed_stream_final_array[k][0]) {
              count += 1;
            }
          }
          detailed_stream_celldata.push(
            { s: { r: ind, c: 0 }, e: { r: ind + count - 1, c: 0 } },
          );
        }
      });
      detailed_stream_excel_data['!merges'] = detailed_stream_celldata;
      XLSX.utils.book_append_sheet(workbook, detailed_stream_excel_data, 'Detailed Stream Data');
    }
    // Detailed Stream Data End
    // CLRO Section Summary Start
    if (reportData.report_dict.clro_elem_summary && Object.keys(reportData.report_dict.clro_elem_summary).length && reportData.report_dict.clro_overview && Object.keys(reportData.report_dict.clro_overview).length) {
      // sorting explorer tab based on below value GB-2927 added by chandrashekhar
      // const explorerTabValue = ['DSSRO mode', 'PV', 'Recovery', 'Flow', 'Total Circuits', 'Duration', 'Volume'];
      const explorerTabValue = ['DSSRO mode', 'PV', 'Recovery', 'Flow', 'Total', 'Duration', 'Volume'];
      // sorting explorer tab based on upper value GB-2927 added by chandrashekhar
      const { clro_elem_summary } = reportData.report_dict;
      const clroOverView = reportData.report_dict.clro_overview;
      const clro_elem_system_units = reportData.report_dict.system_units;
      const clro_elem_herder_val = ['Circuit', 'Element', 'Recovery', 'Feed Flow', 'Feed Press', 'Feed TDS', 'Conc Flow', 'Perm Flow', 'Perm TDS'];
      /* DSSRO OVERVIEW START */
      const clroOverViewArr = [['Parameters', 'Units', 'Values']];
      Object.keys(clroOverView).map((key) => {
        // Object.keys(clroOverView[key]).sort().map((element, elementInd) => {
        explorerTabValue.map((element) => {
          if (element !== 'units') {
            const units = clroOverView[key].units[element];
            if (Object.prototype.toString.call(clroOverView[key][element]) === '[object Object]') {
              Object.keys(clroOverView[key][element]).map((ele, ind) => {
                clroOverViewArr.push(clroOverViewContent(ele, units, clroOverView[key][element][ele], ind, clroOverView[key], element, clro_elem_system_units['Volume Flow']));
              });
            } else {
              clroOverViewArr.push(clroOverViewContent(element, units, clroOverView[key][element], 0, clroOverView[key], element, clro_elem_system_units['Volume Flow']));
            }
          }
        });
      });
      /* DSSRO OVERVIEW END */
      /* DSSRO Flow Summary (Element Level) START */
      const clro_elem_summary_data = [clro_elem_herder_val];

      clro_elem_summary['CLRO Unit ID'].map((key) => {
        const clroContent = clro_elem_summary[key];
        Object.keys(clroContent.Elements).map((data) => {
          Object.keys(clroContent.Elements[data]).map((ele) => {
            const finalArry = [data, ele];
            const obj = clroContent.Elements[data][ele];
            clro_elem_herder_val.map((hVal) => {
              if (obj[hVal]) {
                finalArry.push(getFlowValue(obj[hVal], 2, clro_elem_system_units['Volume Flow']));
              }
            });
            clro_elem_summary_data.push(finalArry);
          });
        });
      });
      clro_elem_herder_val.map((hVal, hvalInd) => {
        if (hVal === 'Recovery') {
          clro_elem_herder_val[hvalInd] = `${hVal} (%)`;
        } else if (['Feed Flow', 'Conc Flow', 'Perm Flow'].indexOf(hVal) >= 0) {
          clro_elem_herder_val[hvalInd] = `${hVal} (${clro_elem_system_units['Volume Flow']})`;
        } else if (['Feed Press'].indexOf(hVal) >= 0) {
          clro_elem_herder_val[hvalInd] = `${hVal} (${clro_elem_system_units.Pressure})`;
        } else if (['Feed TDS', 'Perm TDS'].indexOf(hVal) >= 0) {
          clro_elem_herder_val[hvalInd] = `${hVal} (mg/L)`;
        }
      });
      /* DSSRO Flow Summary (Element Level) END */
      /* DSSRO Stream Composition START */
      const CLRO_Stream_composition = [['Concentrations (mg/L as ion)']];
      // create header start
      const arr = [''];
      const arr1 = [''];
      clro_elem_summary['CLRO Unit ID'].map((key) => {
        const clroContent = clro_elem_summary[key];
        Object.keys(clroContent.Concentrations).map((ele) => {
          arr.push(ele);
          arr1.push(Object.keys(clroContent.Concentrations[ele]));
          for (let k = 1; k < Object.keys(clroContent.Concentrations[ele]).length; k += 1) {
            arr.push('');
          }
        });
      });
      CLRO_Stream_composition.push(arr, arr1.flat(Infinity));
      // create header start
      clro_elem_summary['CLRO Unit ID'].map((key) => {
        const catKey = Object.keys(Object.values(Object.values(clro_elem_summary[key].Concentrations)[0])[0]);
        const clroContent = clro_elem_summary[key];
        catKey.map((eleData) => {
          const finalArry = [eleData];
          Object.keys(clroContent.Concentrations).map((element) => {
            Object.keys(clroContent.Concentrations[element]).map((ele) => {
              if (element === 'Feed') {
                finalArry.push(getFlowValue(clroContent.Concentrations[element][ele][eleData], 2));
              } else {
                finalArry.push(getFlowValue(clroContent.Concentrations[element][ele][eleData], 2));
              }
            });
          });
          CLRO_Stream_composition.push(finalArry);
        });
      });
      /* DSSRO Stream Composition END */
      const clro_elem_finalArry = [clroOverViewArr, clro_elem_summary_data, CLRO_Stream_composition];
      const clro_elem_celldata = [];
      const clro_elem_excel_data = XLSX.utils.aoa_to_sheet([''.split('')]);
      clro_elem_finalArry.map((ele, ind) => {
        let startingrow = 0;
        for (let k = 0; k < ind; k += 1) {
          startingrow += clro_elem_finalArry[k].length;
        }
        startingrow += ind;
        if (ind === clro_elem_finalArry.length - 1) {
          clro_elem_celldata.push(
            { s: { r: startingrow, c: 0 }, e: { r: startingrow, c: clro_elem_finalArry[ind][1].length - 1 } },
            { s: { r: startingrow + 1, c: 0 }, e: { r: startingrow + 2, c: 0 } },
            { s: { r: startingrow + 1, c: 1 }, e: { r: startingrow + 2, c: 1 } },
            { s: { r: startingrow + 1, c: 2 }, e: { r: startingrow + 1, c: 4 } },
            { s: { r: startingrow + 1, c: 5 }, e: { r: startingrow + 1, c: 7 } }
          );
        }
        XLSX.utils.sheet_add_aoa(clro_elem_excel_data, ele, { origin: { r: startingrow, c: 0 } });
      });
      clro_elem_excel_data['!merges'] = clro_elem_celldata;
      XLSX.utils.book_append_sheet(workbook, clro_elem_excel_data, 'CLRO Section Summary');
    }
    // CLRO Section Summary End
    XLSX.writeFile(workbook, `${filename}.xlsx`);
  };
  useEffect(() => {
    handleExportExcel();
  }, []);
  return (
    <div />
  );
};
export default ExcelSheetFile;
